<template>
  <v-dialog width="450px" v-model="viewMenu" presistent>
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout row wrap v-if="gelenk">
          <v-flex xs3>
            <v-subheader v-text="'N-Wert:'"></v-subheader>                  
          </v-flex>
          <v-flex xs4>
            <v-switch v-model="gelenk.Werte[0]" :false-value="0" :true-value="-1" :label="checkSwitchLabel(gelenk.Werte[0])"></v-switch>
          </v-flex>
          <v-flex xs4>
            <v-text-field label="Feder" type="number" v-model.number="gelenk.Werte[0]" :suffix="KraftEinheit.name + '/' + LängenEinheit.name"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-subheader v-text="'Q-Wert:'"></v-subheader>                  
          </v-flex>
          <v-flex xs4>
            <v-switch v-model="gelenk.Werte[1]" :false-value="0" :true-value="-1" :label="checkSwitchLabel(gelenk.Werte[1])"></v-switch>              
          </v-flex>          
          <v-flex xs4>
              <v-text-field label="Feder" type="number" v-model.number="gelenk.Werte[1]" :suffix="KraftEinheit.name + '/' + LängenEinheit.name"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-subheader v-text="'M-Wert:'"></v-subheader>                  
          </v-flex>
          <v-flex xs4>
            <v-switch v-model="gelenk.Werte[2]" :false-value="0" :true-value="-1" :label="checkSwitchLabel(gelenk.Werte[2])"></v-switch>               
          </v-flex>          
          <v-flex xs4>
              <v-text-field label="Feder" type="number" v-model.number="gelenk.Werte[2]" :suffix="KraftEinheit.name + LängenEinheit.name + '/rad'" ></v-text-field>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
                <v-btn v-if="!$store.getters.newGelenk" @click="deleteGelenk()" color="grey lighten-2"><v-icon dark color="red">delete_forever</v-icon>Löschen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import GelenkClass from '../../js/Gelenk.js'

export default {
    data(){
        return{
            gelenk: undefined,
            LängenEinheit: this.$store.state.LängenEinheiten.m,
            KraftEinheit: this.$store.state.KraftEinheiten.kN
        }
    },
    computed: {
        title() { return this.$store.getters.newGelenk == true ? 'Neues Gelenk' : 'Gelenk Bearbeiten'},
        viewMenu: {
            get() { return this.$store.getters.vGelenkMenu },   
            set(value) { this.$store.commit('setvGelenkMenu', value)} 
        },
        cGelenk() { return this.$store.getters.cGelenk },
    },
    methods: {
        checkSwitchLabel(payload){
            switch (payload){
                case -1: return 'fest';
                case 0: return 'frei';
                default: return 'Feder'
            }
        },
        apply(){
            this.gelenk.Werte[0] > 0 ? this.gelenk.Werte[0] *=(this.KraftEinheit.value/this.LängenEinheit.value) : this.gelenk.Werte[0]
            this.gelenk.Werte[1] > 0 ? this.gelenk.Werte[1] *=(this.KraftEinheit.value/this.LängenEinheit.value) : this.gelenk.Werte[1]
            this.gelenk.Werte[2] > 0 ? this.gelenk.Werte[2] *=(this.KraftEinheit.value*this.LängenEinheit.value) : this.gelenk.Werte[2]
            this.$store.commit('GelenkDialogApply', this.gelenk)
            this.gelenk = undefined
        },
        cancel(){
            this.viewMenu = false
            this.gelenk = undefined
        },
        deleteGelenk(){
            this.$store.commit('GelenkDialogDelete')
        }
    },
    beforeUpdate(){
        if (!this.gelenk && this.viewMenu) {
            let cN = this.cGelenk.Werte[0] > 0 ? this.cGelenk.Werte[0]/(this.KraftEinheit.value/this.LängenEinheit.value) : this.cGelenk.Werte[0]
            let cQ = this.cGelenk.Werte[1] > 0 ? this.cGelenk.Werte[1]/(this.KraftEinheit.value/this.LängenEinheit.value) : this.cGelenk.Werte[1]
            let cM = this.cGelenk.Werte[2] > 0 ? this.cGelenk.Werte[2]/(this.KraftEinheit.value*this.LängenEinheit.value) : this.cGelenk.Werte[2]
          this.gelenk = new GelenkClass(null, cN, cQ, cM)
        } 
    },
}
</script>
